(function() {
    angular.module('emarket.main.post').factory('ShareSheet', ['$rootScope', '$mdBottomSheet', function($rootScope, $mdBottomSheet) {
        return {
            show: function show(post) {
                return $mdBottomSheet
                    .show({
                        templateUrl: 'main/post/share-sheet/share.sheet.tpl.html',
                        controller: 'ShareSheetController as vm',
                        locals: {
                            post: post
                        },
                        parent: 'html'
                    })
                    .then(function() {
                        $rootScope.$emit('scroll:disable', false);
                    })
                    .catch(function() {
                        $rootScope.$emit('scroll:disable', false);
                    });
            }
        };
    }]);
}());
